<template>
  <com-page>
    <com-search :columns="searchColumn" @confirm="handleSearch">
      <template>
        <el-button type="primary" @click="handleExport" :disabled="exportLoading">导出</el-button>
      </template>
    </com-search>
    <com-card>
      <com-table :api="api" :columns="columns" ref="tableRef">
        <template #createTime="row">
          {{ row.data.createTime | formatDate }}
        </template>
        <template #lastChargeTime="row">
          <div v-if="row.data.lastChargeTime">
            {{ row.data.lastChargeTime | formatDate }}
          </div>
        </template>
        <template #status="row">
          <el-switch
            v-model="row.data.status"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatus(row.data)"
          >
          </el-switch>
        </template>
        <template #operation="row">
          <el-button type="primary" size="mini" @click="handleVisit(row.data)">查看</el-button>
        </template>
      </com-table>
    </com-card>
  </com-page>
</template>

<script>
import { userListApi, userStatusApi } from '@/api/user'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      api: userListApi,
      searchColumn: [
        {
          label: '用户ID',
          prop: 'number',
          type: 'input'
        },
        {
          label: '手机号',
          prop: 'phone',
          type: 'input'
        },
        {
          label: '选择网点',
          prop: 'registerStore',
          type: 'input'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'select',
          option: [
            {
              label: '正常',
              value: 1
            },
            {
              label: '冻结',
              value: 0
            }
          ]
        },
        {
          label: '注册时间',
          prop: 'date',
          type: 'date'
        }
      ],
      columns: [
        {
          label: '用户Id',
          prop: 'number',
          width: '150'
        },
        {
          label: '手机号',
          prop: 'phone',
          width: '130'
        },

        {
          label: '选择网点',
          prop: 'registerStore',
          minWidth: '150'
        },
        {
          label: '订单数',
          prop: 'orderCount'
        },
        {
          label: '充值次数',
          prop: 'rechargeCount',
          width: '100'
        },
        {
          label: '充值金额',
          prop: 'rechargeAmount',
          width: '100'
        },
        {
          label: '赠送金额',
          prop: 'giveAmount',
          width: '100'
        },
        {
          label: '钱包余额',
          prop: 'wallet',
          width: '100'
        },
        {
          label: '注册时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime',
          width: '150'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '上次充电时间',
          prop: 'lastChargeTime',
          type: 'slot',
          slotName: 'lastChargeTime',
          width: '150'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          fixed: 'right',
          width: '100'
        }
      ],
      exportQuery: {},
      exportLoading: false
    }
  },
  methods: {
    update() {
      this.$refs.tableRef.getList()
    },
    handleSearch(val) {
      console.log('val :>> ', val)
      const params = { ...val }
      if (val.date && val.date.length) {
        params.queryBeginTime = val.beginTime
        params.queryEndTime = val.endTime
        delete params.beginTime
        delete params.endTime
        delete params.date
      }
      this.exportQuery = { ...params }
      this.$refs.tableRef.handleSearch(JSON.parse(JSON.stringify(params)))
    },
    handleVisit(row) {
      const params = {
        row
      }
      this.$router.push({ name: 'user-detail', params })
    },
    handleStatus(val) {
      const param = {
        status: val.status,
        code: val.code
      }
      userStatusApi(param).then(() => {
        this.update()
      })
    },
    handleExport() {
      const obj = JSON.parse(JSON.stringify(this.exportQuery))
      let i = ''
      let url = ''
      // eslint-disable-next-line prefer-template, guard-for-in, no-restricted-syntax
      for (i in obj) url += '&' + i + '=' + obj[i]
      const downloadUrl = `${process.env.VUE_APP_REQUEST_URL}/xdUser/exportExcel?${url}`

      console.log('host :>> ', downloadUrl)

      utils.download(downloadUrl, '用户列表')
    }
  }
}
</script>
